import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedFirstLayer: {
    title: '',
    menus: [],
  },
  selectedPage: '',
}

export const leftMenuSlice = createSlice({
  name: 'Left Menu Store',
  initialState: initialState,
  reducers: {
    setSelectedMenu: (state, action) => {
      state.selectedFirstLayer = action.payload
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload
    },
    clearSelectedMenu: (state) => {
      state.title = 'Home'
    },
  },
})

export const { setSelectedMenu, setSelectedPage, clearSelectedMenu } = leftMenuSlice.actions;
export default leftMenuSlice.reducer;